import { Accordion } from "PFComponents/accordion/accordion";
import useNotificationsSettings, { FrequencyData } from "PFCore/helpers/use_notifications_settings";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { EditAccountForm } from "../../edit_account.types";
import css from "../edit_account_page.module.scss";
import { NotificationSettingSelect } from "./notification_setting_select";

export const DefaultNotificationSettingsSection = (): JSX.Element => {
  const { t } = useTranslation("saasAdmin");
  const OPTIONS = useNotificationsSettings();
  const [FREQUENCY_OPTIONS, BINARY_OPTIONS, WEEKLY_OPTIONS] = useMemo(
    () => [
      [OPTIONS.weekly, OPTIONS.fortnightly, OPTIONS.monthly, OPTIONS.never],
      [OPTIONS.instantly, OPTIONS.dontReceive],
      [OPTIONS.weekly, OPTIONS.never]
    ],
    []
  );
  const BOOKING_APPROVAL_REQUESTS_OPTIONS = useMemo(
    () => [OPTIONS.instantly, OPTIONS.daily, OPTIONS.weekly, OPTIONS.never],
    []
  );
  const notificationsSelects = useMemo<
    {
      name: keyof EditAccountForm["notificationSettings"];
      options: FrequencyData[];
    }[]
  >(
    () => [
      { name: "messagesStatus", options: BINARY_OPTIONS },
      { name: "digestEmail", options: FREQUENCY_OPTIONS },
      { name: "broadcastInvites", options: BINARY_OPTIONS },
      { name: "regularInvites", options: BINARY_OPTIONS },
      {
        name: "roleInvites",
        options: BINARY_OPTIONS
      },
      { name: "roleFilled", options: BINARY_OPTIONS },
      { name: "ownerRoleFilled", options: BINARY_OPTIONS },
      { name: "roleClosed", options: BINARY_OPTIONS },
      { name: "interestExpressed", options: BINARY_OPTIONS },
      { name: "interestsSummary", options: WEEKLY_OPTIONS },
      { name: "marketplaceRoleClosed", options: BINARY_OPTIONS },
      { name: "bookingApprovalRequests", options: BOOKING_APPROVAL_REQUESTS_OPTIONS },
      { name: "feedbackRequest", options: BINARY_OPTIONS },
      { name: "roleChanged", options: BINARY_OPTIONS }
    ],
    []
  );
  return (
    <div>
      <Accordion header={t("accounts.account.notificationSettings.header")}>
        <div className={css.sectionContainer}>
          {notificationsSelects.map(({ name, options }) => (
            <NotificationSettingSelect key={name} name={name} options={options} />
          ))}
        </div>
      </Accordion>
    </div>
  );
};
